import React, { ButtonHTMLAttributes } from 'react';
import PulseLoader from 'react-spinners/PulseLoader';

import { Container } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'large' | 'medium' | 'small';
  color?: 'primary' | 'secondary';
  isLoading?: boolean;
  disableForce?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  size = 'medium',
  color = 'primary',
  isLoading = false,
  disableForce = false,
  ...rest
}) => (
  <Container
    type="button"
    disabled={disableForce || isLoading}
    color={color}
    size={size}
    isLoading={isLoading}
    disableForce={disableForce}
    {...rest}
  >
    {isLoading
      ? (
        <PulseLoader
          size={8}
          color="#fff"
          loading={isLoading}
        />
      )
      : children}

  </Container>
);

export default Button;
